import React from 'react';
import IntroSection from '../components/IntroSection';
import WhyusOverviewSection from '../components/WhyusOverviewSection';
import ClientsSection from '../components/ClientsSection';
import WhyusTeam from '../components/WhyusTeam';
import WhyusImplementation from '../components/WhyusImplementation';
import Consultancy from '../components/Consultancy';
import WhyusGrow from '../components/WhyusGrow';
import WhyusControl from '../components/WhyusControl';
import WhyusPartner from '../components/WhyusPartner';
import WhyusEfficiency from '../components/WhyusEfficiency';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const WhyUs =()=>{
    return (
        <div>
            <IntroSection title="ACCELERATING DIGITAL TRANSFORMATION" paragraph="Tailored solutions that leverage unique elite processes and deep technical expertise, ensuring rapid, reliable, and scalable product development." backgroundImage="/images/whyus-bg.webp"/>
            <WhyusOverviewSection/>
            <ClientsSection/>
            <WhyusTeam/>
            <WhyusImplementation/>
            <Consultancy/>
            <WhyusGrow/>
            <WhyusControl/>
            <WhyusPartner/>
            <WhyusEfficiency/>
            <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>
            

        </div>
    )
}
export default WhyUs;